/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */

import { createAction } from '../../../../../modules/app/createAction';
import {
    WIDGET_PERSONAL_ACCOUNT_LOAD_DATA,
    WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_ERROR,
    WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_SUCCESSFUL,
} from './constants/widgetPersonalAccountActionConstants';
import {
    IWidgetPersonalAccountLoadDataErrorPayload,
    TWidgetPersonalAccountLoadDataAction,
    TWidgetPersonalAccountLoadDataErrorAction,
    TWidgetPersonalAccountLoadDataSuccessfulAction,
} from './types/widgetPersonalAccountActionType';
import { IWidgetPersonalAccountReducer } from './types/widgetPersonalAccountType';

/*
* -------------------------------------------
*                LOAD DATA
* -------------------------------------------
*/

export const widgetPersonalAccountLoadData = (): TWidgetPersonalAccountLoadDataAction =>
    createAction(WIDGET_PERSONAL_ACCOUNT_LOAD_DATA);

export const widgetPersonalAccountLoadDataSuccessful =
    (payload: IWidgetPersonalAccountReducer['data']): TWidgetPersonalAccountLoadDataSuccessfulAction =>
        createAction(WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_SUCCESSFUL, payload);

export const widgetPersonalAccountLoadDataError =
    (payload: IWidgetPersonalAccountLoadDataErrorPayload): TWidgetPersonalAccountLoadDataErrorAction =>
    createAction(WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_ERROR, payload);

export type TWidgetPersonalAccountAction =
    TWidgetPersonalAccountLoadDataAction
    | TWidgetPersonalAccountLoadDataErrorAction
    | TWidgetPersonalAccountLoadDataSuccessfulAction
    ;
